// Shared gating logic for attachment answers in the wizard "Next"/map-step
// checks. Extracted so it can be unit-tested independently of MainWizardView.
//
// A single attachment answer is an object { value } while the user is on the
// page, but is rehydrated as an array [ { value } ] on reload (see the reducer's
// gotQuestionnaire, which stores non-`do_no_repeat` roots via Array.filter).
// This reads the file id out of either shape.
export const attachmentFileId = ans => {
    const single = Array.isArray(ans) ? ans[ans.length - 1] : ans;
    return (single && single.value) || '';
};

// True when a mandatory attachment question has no file — including right after
// its file is deleted, when an empty answer object still exists in state.
export const isEmptyMandatoryAttachment = (question, answer) =>
    !!(question &&
        question.type === 'attachment' &&
        !question.is_multi &&
        question.mandatory &&
        !attachmentFileId(answer).trim());
